import ReducersFactory from '../../lib/reducers/ReducersFactory';
import { EVENT_DEFAULT } from '../constants/initStateItems';

const event = new ReducersFactory('event', [], EVENT_DEFAULT)


export default event.reducer